module.exports = __webpack_public_path__ + "fonts/Inter-MediumItalic.woff";